import { render } from "./AppLogs.vue?vue&type=template&id=238f64f3&scoped=true"
import script from "./AppLogs.vue?vue&type=script&lang=js"
export * from "./AppLogs.vue?vue&type=script&lang=js"

import "./AppLogs.vue?vue&type=style&index=0&id=238f64f3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-238f64f3"]])

export default __exports__